import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.function.name.js";
import { Node } from 'tiptap';
import { wrappingInputRule, setBlockType, toggleWrap } from 'tiptap-commands';
var KvBlock = /*#__PURE__*/function (_Node) {
  _inherits(KvBlock, _Node);
  var _super = _createSuper(KvBlock);
  function KvBlock() {
    _classCallCheck(this, KvBlock);
    return _super.apply(this, arguments);
  }
  _createClass(KvBlock, [{
    key: "name",
    get: function get() {
      return 'kv_editor_block';
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;
      return {
        group: 'block',
        draggable: true,
        defining: true,
        content: 'block+',
        toDOM: function toDOM() {
          return ['div', {
            'data-type': _this.name
          }, 0];
        },
        parseDOM: [{
          tag: "[data-type=\"".concat(this.name, "\"]")
        }]
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return setBlockType(type);
      };
    }

    /*
    keys({ type }) {
      return {
        'Ctrl-d': toggleWrap(type),
        'Cmd-d': toggleWrap(type)
      }
    }
     inputRules({ type }) {
      return [
        wrappingInputRule(/^\s*;\s$/, type),
      ]
    }
    */
  }, {
    key: "view",
    get: function get() {
      return {
        template: "\n        <div class=\"kv-editor-block\" data-type=\"kv_editor_block\" contenteditable=\"true\">\n          <div class=\"kv-editor-block-add-item-btn\" contenteditable=\"false\"><i class=\"fal fa-plus\"></i></div>\n          <div class=\"kv-editor-block-drag-handle\" data-drag-handle contenteditable=\"false\"><i class=\"fal fa-grip-vertical\"></i></div>\n          <div class=\"kv-editor-block-content\" ref=\"content\" contenteditable=\"true\"></div>\n        </div>\n      "
      };
    }
  }]);
  return KvBlock;
}(Node);
export { KvBlock as default };